import { createAsyncThunk } from '@reduxjs/toolkit'
import { getLimboGameReportService, getPlinkoGameReportService, getMineGameReportService, getCoinHeistGameReportService, getHiloGameReportService, getDiceGameReportService, getCoinFlipGameReportService, getKenoGameReportService, getRouletteGameReportService } from 'network/services/game.service'

export const fetchPlinkoGameReport = createAsyncThunk(
  'fetch/plinkoGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getPlinkoGameReportService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchLimboGameReport = createAsyncThunk(
  'fetch/limboGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getLimboGameReportService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchMineGameReport = createAsyncThunk(
  'fetch/mineGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getMineGameReportService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchCoinHeistGameReport = createAsyncThunk(
  'fetch/coinHeistGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getCoinHeistGameReportService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchDiceGameReport = createAsyncThunk(
  'fetch/diceGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getDiceGameReportService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchHiloGameReport = createAsyncThunk(
  'fetch/hiloGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getHiloGameReportService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchCoinFlipGameReport = createAsyncThunk(
  'fetch/coinFlipGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getCoinFlipGameReportService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchKenoGameReport = createAsyncThunk(
  'fetch/kenoGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getKenoGameReportService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchRouletteGameReport = createAsyncThunk(
  'fetch/rouletteGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getRouletteGameReportService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
